'use strict';

angular.module('app').directive('inputCounter', function ($timeout) {
    return {
        restrict: 'A',
        scope: { 
            value: '=value',
            disabled: '=',
            callback: '&',
            watchMax: '='
        },
        template: '<span class="counter-minus" ng-class="{ disabled: disabled }" ng-click="minus()">-</span>\
                  <input type="text" ng-disabled="disabled" ng-class="{ disabled: disabled }" class="counter-field" ng-model="value" ng-change="changed()" ng-readonly="readonly">\
                  <span  class="counter-plus"  ng-class="{ disabled: disabled }" ng-click="plus()">+</span>',
        link: function (scope, element, attributes) {
            // Make sure the value attribute is not missing.
            if (angular.isUndefined(scope.value)) {
                scope.value = 0;
            }

            function getMax() {
                return angular.isUndefined(attributes.max) ? null : parseInt(attributes.max);
            }

            var min = angular.isUndefined(attributes.min) ? null : parseInt(attributes.min);
            var max = getMax()
            var step = angular.isUndefined(attributes.step) ? 1 : parseInt(attributes.step);

            element.addClass('counter-container');

            if (scope.watchMax) {
                scope.$watch(function() {
                    return attributes.max
                }, function(newVal, oldVal) {
                    if (newVal !== oldVal) {
                        max = getMax(newVal)
    
                        if (max && (scope.value > max || scope.value + step > max)) {
                            setValue(max);
                        }
                    }
                })
            }
           

            // If the 'editable' attribute is set, we will make the field editable.
            scope.readonly = angular.isUndefined(attributes.editable) ? true : false;

            /**
             * Sets the value as an integer.
             */
            var setValue = function (val, add) {
                scope.value = parseInt(val);
                if (scope.callback) {
                    $timeout(function() {
                        scope.callback({ add : add });
                    });
                }
            }

            // Set the value initially, as an integer.
            setValue(scope.value);

            /**
             * Decrement the value and make sure we stay within the limits, if defined.
             */
            scope.minus = function () {
                if (scope.disabled) {
                    return false;
                }

                if (min && (scope.value <= min || scope.value - step <= min) || min === 0 && scope.value < 1) {
                    setValue(min, false);
                    return false;
                }
                setValue(scope.value - step, false);
            };

            /**
             * Increment the value and make sure we stay within the limits, if defined.
             */
            scope.plus = function () {
                if (scope.disabled) {
                    return false;
                }

                if (max && (scope.value >= max || scope.value + step >= max)) {
                    setValue(max, true);
                    return false;
                }
                setValue(scope.value + step, true);
            };

            /**
             * This is only triggered when the field is manually edited by the user.
             * Where we can perform some validation and make sure that they enter the
             * correct values from within the restrictions.
             */
            scope.changed = function () {
                if (scope.disabled) {
                    return false;
                }
                // If the user decides to delete the number, we will set it to 0.
                if (!scope.value) setValue(0);

                // Check if what's typed is numeric or if it has any letters.
                if (/[0-9]/.test(scope.value)) {
                    setValue(scope.value);
                }
                else {
                    setValue(scope.min);
                }

                // If a minimum is set, let's make sure we're within the limit.
                if (min && (scope.value <= min || scope.value - step <= min)) {
                    setValue(min);
                    return false;
                }

                // If a maximum is set, let's make sure we're within the limit.
                if (max && (scope.value >= max || scope.value + step >= max)) {
                    setValue(max);
                    return false;
                }
                // Re-set the value as an integer.
                setValue(scope.value);
            };
        }
    }
});